import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SaveUrlGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (state.url.includes('trip-reports/view-trip-report') && route.queryParams.tripId) {
      localStorage.setItem('msal_return_url', state.url);
    }
    return true;
  }
}